import * as z from "zod";
import {
  FlowContentNodeSchema,
  type FlowContentNode,
} from "./flow-content-node-schema";

/**
 * Heading node with level 1-3.
 */
const HeadingNodeSchema_ = z.object({
  type: z.literal("heading"),
  level: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  content: z.array(FlowContentNodeSchema),
});

/** Base type from schema inference (no index signature) */
type HeadingNodeBase = Omit<z.infer<typeof HeadingNodeSchema_>, "content"> & {
  content: FlowContentNode[];
};

/** Full type with index signature for FlowContentNode compatibility */
export type HeadingNode = HeadingNodeBase & { [key: string]: unknown };

export const HeadingNodeSchema: z.ZodType<HeadingNode> = HeadingNodeSchema_;
